import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemListComponent } from '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component';
import { WebSpotlightTemplatesViewModel } from '../web-spotlight-templates-view-model';

@Component({
  selector: 'app-web-spotlight-template-list',
  templateUrl:
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.html',
  styleUrls: [
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.scss',
    './web-spotlight-template-list.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WebSpotlightTemplateListComponent extends DisplayableItemListComponent {
  constructor(
    webSpotlightTemplatesViewModel: WebSpotlightTemplatesViewModel // Provided by parent component
  ) {
    super(webSpotlightTemplatesViewModel);
  }
}
